import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function EyeIcon() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsx("svg", {
      width: "16",
      height: "12",
      viewBox: "0 0 16 12",
      children: /*#__PURE__*/_jsx("path", {
        "data-fill-rule": "fill",
        d: "M8 12c3.6 0 6.4-3.1 7.6-4.9.5-.7.5-1.6 0-2.3C14.4 3.1 11.6 0 8 0 4.4 0 1.6 3.1.4 4.9c-.5.7-.5 1.6 0 2.2C1.6 8.9 4.4 12 8 12zm0-9c1.7 0 3 1.3 3 3S9.7 9 8 9 5 7.7 5 6s1.3-3 3-3z"
      })
    })
  );
}